export const sortGroupDrillDownFields = {
  AGENCY_NAME: "AgencyNameAndNo",
  PRODUCER_1_NAME: "ProducerName1",
  PRODUCER_2_NAME: "ProducerName2",
  PRODUCER_1_CODE: "ProducerCode1",
  PRODUCER_2_CODE: "ProducerCode2",
  MONTH: "ProdMonthName",
  DAY: "ProdDayName",
  TIME: "ProdHourName",
  WEEK: "ProdWeekName",
};

export const drillDownSortFieldOptions = [
  { label: "Agency", value: sortGroupDrillDownFields.AGENCY_NAME },
  { label: "Month", value: sortGroupDrillDownFields.MONTH },
  { label: "Week", value: sortGroupDrillDownFields.WEEK },
  {
    label: "Day of week",
    value: sortGroupDrillDownFields.DAY,
  },
  { label: "Time of day", value: sortGroupDrillDownFields.TIME },
  { label: "Producer 1", value: sortGroupDrillDownFields.PRODUCER_1_CODE },
  { label: "Producer 2", value: sortGroupDrillDownFields.PRODUCER_2_CODE },
];

export const dayOfWeek = {
  ALL_DAYS: 0,
  SUNDAY: 1,
  MONDAY: 2,
  TUESDAY: 3,
  WEDNESDAY: 4,
  THURSDAY: 5,
  FRIDAY: 6,
  SATURDAY: 7,
};

export const dayOfWeekOptions = [
  { value: dayOfWeek.MONDAY, label: "Monday" },
  { value: dayOfWeek.TUESDAY, label: "Tuesday" },
  { value: dayOfWeek.WEDNESDAY, label: "Wednesday" },
  { value: dayOfWeek.THURSDAY, label: "Thursday" },
  { value: dayOfWeek.FRIDAY, label: "Friday" },
  { value: dayOfWeek.SATURDAY, label: "Saturday" },
  { value: dayOfWeek.SUNDAY, label: "Sunday" },
];
